import { Outlet } from 'react-router';

export const LegalLayout: React.FC = () => {
  return (
    <div className='font-mono flex-1 flex flex-col items-center mx-auto container pb-12'>
      <Outlet />
    </div>
  );
};
